import {useEffect} from 'react'

import {
  updateLabelConfig,
  labelConfigSelector,
  referenceNumberErrorMessageSelector,
  labelShippersSelector,
  ADDITIONAL_DEPENDENT_PROPERTIES,
} from '../../../../data/labelInfos/index.js'
import {getState, useSelector} from '../../../../store.js'
import {UPS} from '../../../../common/constants/ShipperNames.js'
import ConfigTextInput from '../ConfigTextInput.js'
import {LABEL_PROPERTY_IS_MAIL_INNOVATIONS} from './MailInnovations.js'
import {useLabelConfigContext} from '../../LabelConfigContext.js'

const LABEL_PROPERTY = 'cost_center'
const VALID_SHIPPER_TYPES = [UPS]

function labelPropertiesFunc(shipperType, labelInfoID) {
  const {is_mail_innovations} = labelConfigSelector(getState(), {labelInfoID})

  return is_mail_innovations ? [LABEL_PROPERTY] : []
}

const COST_CENTER_DEPENDENT_PROPERTIES = [
  ...ADDITIONAL_DEPENDENT_PROPERTIES,
  LABEL_PROPERTY_IS_MAIL_INNOVATIONS,
]

function dependentPropertiesFunc() {
  return COST_CENTER_DEPENDENT_PROPERTIES
}

function defaultCostCenterSelector(state, {labelInfoID}) {
  const shippers = labelShippersSelector(state, {labelInfoID})

  return shippers.reduce((prev, {vendor, vendor_config}) => {
    if (VALID_SHIPPER_TYPES.includes(vendor) && !prev) {
      prev = vendor_config.cost_center
    }

    return prev
  }, null)
}

const VALID_LABEL_PROPERTIES = [LABEL_PROPERTY]

export default function CostCenter() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = CostCenter.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const labelConfig = useSelector((state) =>
    labelConfigSelector(state, {labelInfoID}),
  )
  const defaultCostCenter = useSelector((state) =>
    defaultCostCenterSelector(state, {labelInfoID}),
  )
  const error = useSelector((state) =>
    referenceNumberErrorMessageSelector(state, {labelInfoID, shipperType}),
  )

  const cost_center = labelConfig.cost_center
  const is_mail_innovations = labelConfig.is_mail_innovations || false

  useEffect(() => {
    if (is_mail_innovations && defaultCostCenter && cost_center === undefined) {
      updateLabelConfig(labelInfoID, {
        cost_center: defaultCostCenter,
      })

      onChange()
    }
  }, [is_mail_innovations, defaultCostCenter, cost_center])

  return (
    <ConfigTextInput
      label="Mail Innovations Cost Center"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {[labelProperty]: value})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      errorMessage={error}
      hide={!is_mail_innovations}
    />
  )
}

CostCenter.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc,
    dependentPropertiesFunc,
    validLabelPropertiesFunc() {
      return VALID_LABEL_PROPERTIES
    },
  },
]
